import type { Permission } from '@bitstopco/bitstop-theme';

/** Whether `userPermissions` grants `permission` ("resource.action"). */
export const hasPermission = (
  userPermissions: Record<string, string[]> | undefined,
  permission: Permission,
): boolean => {
  const [name, value] = permission.split('.');
  return (userPermissions?.[name] || []).indexOf(value) !== -1;
};

export const fetchPermission =
  (userPermissions?: Record<string, string[]>) =>
  async (permission: Permission): Promise<boolean> => {
    try {
      return hasPermission(userPermissions, permission);
    } catch {
      return false;
    }
  };
